(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker.Plans.SeminarPlan",
                    {
                        url: "/SeminarPlan/{seminarPlanId}",
                        component: "seminarplan",
                        PageTitle: "Marketing Tracker - Seminar Plan",
                        resolve: {
                            seminarPlanDocument: ["$stateParams", "marketingPlanApi", "marketingTrackerAgent",
                                function ($stateParams, marketingPlanApi, marketingTrackerAgent) {
                                    return marketingPlanApi
                                        .getSeminarPlanDocument(marketingTrackerAgent.AgentId, $stateParams.seminarPlanId)
                                        .then(function (file) {
                                            return URL.createObjectURL(file);
                                        });
                                }]
                        }
                    });
        }
    ]);

    app.component("seminarplan",
        {
            templateUrl: "App/Tools/MarketingTracker/Plans/SeminarPlan/seminarplan-template.html",
            controller: seminarPlanController,
            bindings: {
                seminarPlanDocument: "<"
            }
        });

    seminarPlanController.$inject = ["$scope"];
    function seminarPlanController($scope) {
        var $ctrl = this;

        $scope.$on("$destroy",
            function () {
                if ($ctrl.seminarPlanDocument)
                    URL.revokeObjectURL($ctrl.seminarPlanDocument);
            });
    }

})(window.app);